import React, { useEffect, useState } from "react";
import RichTextEditor from './RichTextEditor';

const HtmlEditor = ({ isOpen, onClose, onSave, rect }) => {


  const [richText, setRichText] = useState("");
  const [plainText, setPlainText] = useState("");

  const handleSave = () => {

    console.log("On Save");
    console.log(rect.richText);

    rect.richText = richText;
    rect.plainText = plainText;

    if (onSave) onSave();
    onClose();
  };


  useEffect(() =>{

    console.log("On Paste");
    console.log(rect.richText);

  }, [rect])

  useEffect(() =>{

    setRichText(rect.richText);
    setPlainText(rect.plainText);

    console.log("On Paste");
    console.log(rect.richText);

  }, [])


  function handleHtmlChange(html, text)
  {
    
    // selectedRect[0].imageName = fileName;
    // selectedRect[0].richText = `<![CDATA [${html}]]>`;
      setRichText(html);
      setPlainText(text);


      // rect.richText=html;
      // rect.plainText=text;
      
  }


  if (!isOpen) return null;

  const styles = {
    backdrop: {
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0, 0, 0, 0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 50,
    },
    modal: {
      backgroundColor: "#fff",
      borderRadius: "8px",
      padding: "20px",
      width: "90%",
      maxWidth: "800px",
      maxHeight: "90vh",      
      overflowY: "auto",
      overscrollBehaviorY: "contain",
      boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
    },
    label: { display: "block", marginBottom: "15px", fontSize: "14px" },
    input: {
      display: "block",
      width: "100%",
      padding: "6px 10px",
      marginTop: "5px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      fontSize: "14px",
      boxSizing: "border-box",
    },
    colorInput: {
      display: "inline-block",
      width: "60px",
      height: "35px",
      marginTop: "5px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      cursor: "pointer",
    },
    modalButtons: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "10px",
      marginTop: "20px",
    },
    button: {
      padding: "6px 12px",
      fontSize: "14px",
      borderRadius: "4px",
      border: "none",
      cursor: "pointer",
    },
    cancel: { backgroundColor: "#e0e0e0" },
    save: { backgroundColor: "#007bff", color: "#fff" },
  };


  return (
    <div style={styles.backdrop}>
      <div id="scroll-list" style={styles.modal}>
        <h2>Html Text</h2>


        <div style={{ width: '100%', maxWidth: '800px' }}>              
            <RichTextEditor value={richText} onHtmlChange={handleHtmlChange} rect = {rect}/>           
        </div>
        
        {/* Buttons */}
        <div style={styles.modalButtons}>
          <button style={{ ...styles.button, ...styles.cancel }} onClick={onClose}>
            Cancel
          </button>
          <button style={{ ...styles.button, ...styles.save }} onClick={handleSave}>
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default HtmlEditor;


